import useSWR from 'swr';

import { generateApiPath, getCollection } from '#app/Handler/api';
import CountryEntryPoints from '#app/entrypoints/country';
import { Option } from '#app/typings/utils';

type HookReturn = {
  countries: Option[];
};

const useCountries = (): HookReturn => {
  const { data: countries } = useSWR<Option[]>(generateApiPath(CountryEntryPoints.getSelect), getCollection, {
    revalidateOnFocus: false,
  });

  return {
    countries: countries ?? [],
  };
};

export default useCountries;
